export default __webpack_public_path__ + "static/media/drag-gray.99ab0439.svg";